export default {
	state: {
		forms: [],
		activeField: [],
		activeTabForFields: 'elements',
		themingVars: {
			globalFontFamily: "Poppins",
			globalFontColor: "#000000",
			globalLinkColor: "#206C92",
			globalFontSize: "16",
			labelFontWeight: "500",
			labelFontSize: "16",
			labelMarginBottom: "10",
			helpTextColor: "#cccccc",
			helpTextFontSize: "12",
			helpTextMarginTop: "10",
			inputBorderRadius: "4",
			inputBorderColor: "#dcdfe6",
			inputHoverBorderColor: "#c0c4cc",
			inputFocusBorderColor: "#000000",
			inputShadowColor: "#9D9D9D",
			buttonBackground: "#000000",
			buttonBorderColor: "#000000",
			buttonColor: "#FFFFFF"
		}
	},
	// getters: {

	// },

	mutations: {
		SET_ACTIVEFIELD(state, data) {
			state.activeField = data;
		},
		SET_ACTIVETAB(state, data) {
			state.activeTabForFields = data;
		},
	},

	actions: {
		setActiveField({ commit }, data) {
			commit('SET_ACTIVEFIELD', data);
		},
		setActiveTab({ commit }, data) {
			commit('SET_ACTIVETAB', data);
		},

	}
};